module.exports = __webpack_public_path__ + "static/media/dispatch_systemmoduleC-icon7.a3f5c4f1.png";